import { useCallback } from "react";

import { PAGE_CUSTOMISE } from "../../_common/modules/fe-modules/Router/static";
import {
  GA_TOYOTA_FOR_YOU_CUSTOMISE,
  GA_VEHICLE_CUSTOMISE,
} from "../../_common/modules/fe-modules/GA/static";
import useGAViewScreen from "../../_common/modules/fe-modules/GA/useGAViewScreen";
import useCMSPageData from "../../_common/hooks/useCMSPageData";
import { UI_ORGANISM_CONFIGURATOR_SAVE } from "../../_common/modules/Data/static";
import { useDataContext } from "../../_common/modules/Data/DataProvider";

export type UseCustomiseProps = {
  headerContent: any;
  mainContent: any;
  footerContent: any;
};

const useCustomise = (): UseCustomiseProps => {
  const { modalState } = useDataContext();
  useGAViewScreen(GA_TOYOTA_FOR_YOU_CUSTOMISE, GA_VEHICLE_CUSTOMISE);

  const { data } = useCMSPageData({
    page: PAGE_CUSTOMISE,
    queryKey: "customisePage",
  });

  // ********************
  // Data
  // ********************
  const getHeaderContent = useCallback(() => data?.containers?.header, [data]);

  const getMainContent = useCallback(
    () =>
      data?.containers?.main.map((component: any) => {
        if (component.type === UI_ORGANISM_CONFIGURATOR_SAVE) {
          return {
            ...component,
            props: {
              ...component.props,
              isActiveInstance: modalState.id === PAGE_CUSTOMISE,
            },
          };
        }
        return component;
      }),
    [data?.containers?.main, modalState.id],
  );

  const getFooterContent = useCallback(() => data?.containers?.footer, [data]);

  return {
    headerContent: getHeaderContent(),
    mainContent: getMainContent(),
    footerContent: getFooterContent(),
  };
};

export default useCustomise;
